
import InputSwitch from './input-switch.vue'
import SendButton from './send-button.vue'
import InputRecorder from 'components/chat-input/input-recorder.vue'
import Prompts from './prompts.vue'

export default {
  components: {InputRecorder, SendButton, InputSwitch, Prompts},
  props: {
    generating: {type: Boolean, default: false},
    canPush: {type: Boolean, default: false},
    canUpload: {type: Boolean, default: false},
    uploadsEnabled: {type: Boolean, default: true},
    recording: {type: Boolean, default: false}
  },
  emits: ['push', 'stop', 'upload', 'prompt', 'transcribed', 'show-prompts'],
}
